import { Component, input, output } from "@angular/core";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { IconNamesType } from "@shared/types/icon-name.type";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-header-button",
  imports: [IconComponent, RouterLink],
  templateUrl: "./header-button.component.html",
  styleUrl: "./header-button.component.scss",
})
export class HeaderButtonComponent {
  routeLink = input<`/${string}`>();
  icon = input.required<IconNamesType>();
  clicked = output<Event>();
}
